import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Layout } from './Layout';

/**
 * Phase 1: RootLayout is the chrome for routes that need the authenticated
 * layout (header + nav). WorkspaceProvider is mounted at the App.tsx level so
 * the workspace context exists pre-auth — RootLayout no longer wraps it.
 */
export function RootLayout() {
  const { user } = useAuth();
  const location = useLocation();

  const noLayoutRoutes = ['/login', '/forgot-password', '/reset-password', '/auth/callback', '/test/tailwind'];
  const needsLayout = user && !noLayoutRoutes.includes(location.pathname);

  if (needsLayout) {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }

  return <Outlet />;
}
